import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, Col, Form, Input, Radio, Row } from 'antd';
import {
  autoGeneratePassword,
  bulkPasswordReset,
  changeRolePassword,
  resetLinkforBulkUsers,
} from 'redux/slices/resetPassword';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { FormSubmitButtonConatainer } from 'component/form_component/style';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { Link } from 'react-router-dom';
import { refreshToken } from 'redux/slices/authSlice';
import Swal from 'sweetalert2';

export default function ChangePassword({
  handleCancel,
  changePassUser,
  setChangemodal,
  changemodal,
  userCancel,
  singleUserData,
  ...record
}) {
  const dispatch = useDispatch();
  const selectedNode = useSelector((state) => state.selectedNode);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [passwordMatch, setPasswordMatch] = useState(false);
  const [showForm, setShowForm] = useState('random');
  const [passwordAtNextLogon, setPasswordAtNextLogon] = useState(
    singleUserData ? singleUserData.passwordAtNextLogon : ''
  );
  const { mailResetPassword, overrideGlobalStatus, domainMailResetPassword } = useSelector((state) => state.settings);
  const canNotify = overrideGlobalStatus?.settings ? domainMailResetPassword ?? true : mailResetPassword ?? true;

  useEffect(() => {
    if (!singleUserData) {
      dispatch(refreshToken());
    }
  }, []);

  const onFinish = async (values) => {
    if (changemodal) {
      try {
        setLoading(true);
        values.userName = localStorage.getItem('dn');
        const sweetAlert = await dispatch(changeRolePassword(values));
        if (sweetAlert.payload && sweetAlert.payload.status === 200) {
          userCancel();
          await SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'success', buttonColor: 'green' });
        } else if (sweetAlert.payload && sweetAlert.payload.status === 400) {
          if (sweetAlert.payload.data === 'Invalid current password') {
            SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'warning', buttonColor: 'orange' });
          } else {
            SweetSweetAlert({ text: sweetAlert.payload.data, icon: 'error', buttonColor: 'red' });
          }
        } else {
          SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
        }
      } catch (error) {
        await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      } finally {
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);
        let sweetAlert;
        if (showForm === 'manual' || showForm === 'random') {
          let value = [
            {
              strUserName: record.dn,
              strNewPassword: showForm === 'manual' ? values.strNewPassword : '',
              passwordAtNextLogon: passwordAtNextLogon,
              notifyEmail: values.notifyEmail,
              fqdn: values.fqdn,
              domainId: selectedNode.currentdomainId,
            },
          ];
          sweetAlert = await dispatch(bulkPasswordReset(value));
          if (sweetAlert.payload && sweetAlert.payload.status === 200) {
            await SweetSweetAlert({
              sweetData: sweetAlert.payload.data,
              icon: 'success',
              buttonColor: 'green',
            });
            handleCancel();
          } else if (sweetAlert.payload && sweetAlert.payload.status === 400) {
            SweetSweetAlert({ text: sweetAlert.payload.data, icon: 'error', buttonColor: 'red' });
          } else {
            await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
          }
        } else {
          const { protocol, hostname, port } = window.location;
          const currentDomain = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
          let value = [
            {
              strEmail: record.email,
              strUser: record.samAccountName,
              domainName: values.fqdn.split('.')[0],
            },
          ];
          let resetData = {
            links: value,
            resetUrl: currentDomain,
            domainId: selectedNode.currentdomainId,
          };
          sweetAlert = await dispatch(resetLinkforBulkUsers(resetData));
          if (sweetAlert.payload && sweetAlert.payload.status === 200) {
            if (
              sweetAlert?.payload.data[0].split(':')[1].trim() ===
              'Could not send email. MailDelivery is not configured.'
            ) {
              await SweetSweetAlert({
                sweetData: sweetAlert.payload.data[0].split(':')[1],
                icon: 'info',
                buttonColor: 'blue',
              });
            } else {
              await SweetSweetAlert({
                sweetData: sweetAlert.payload.data[0].split(':')[1],
                icon: 'success',
                buttonColor: 'green',
              });
            }
            handleCancel();
          } else if (sweetAlert.payload && sweetAlert.payload.status === 400) {
            SweetSweetAlert({ text: sweetAlert.payload.data, icon: 'error', buttonColor: 'red' });
          } else {
            await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
          }
        }
      } catch (error) {
        await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      } finally {
        setLoading(false);
      }
    }
  };

  const generatePassword = async () => {
    const passwordValue = await dispatch(autoGeneratePassword(selectedNode.currentdomainId));
    if (passwordValue?.payload.status === 200) {
      return passwordValue.payload.data;
    }
  };
  const handleGeneratePassword = async () => {
    const newPassword = await generatePassword();
    form.setFieldsValue({
      strNewPassword: newPassword,
      confirm_password: newPassword,
    });
    setPasswordMatch(true);
  };

  // Custom validator to check if the passwords match
  const validatePasswordMatch = async (_, value) => {
    if (changemodal) {
      const newPassword = form.getFieldValue('newPassword');
      const oldPassword = form.getFieldValue('oldPassword');
      if (oldPassword === value) {
        setPasswordMatch(false);
        throw new Error('Old and new passwords cannot be the same');
      }
      if (newPassword && value === newPassword) {
        setPasswordMatch(true);
        return Promise.resolve();
      } else {
        setPasswordMatch(false);
        throw new Error('Passwords do not match');
      }
    } else {
      const newPassword = form.getFieldValue('strNewPassword');
      if (newPassword && value === newPassword) {
        setPasswordMatch(true);
        return Promise.resolve();
      } else {
        setPasswordMatch(false);
        throw new Error('Passwords do not match');
      }
    }
  };

  const onCheckboxChange = async (e) => {
    setPasswordAtNextLogon(e.target.checked);
    if (e.target.checked) {
      if (singleUserData.passwordNeverExpires) {
        const result = await Swal.fire({
          icon: 'warning',
          title: 'The password has been set for Never Expires. Would you like to modify this and proceed?',
          showConfirmButton: true,
          confirmButtonColor: 'var(--bg-button-default-color)',
          width: '400px',
          heightAuto: false,
          showCancelButton: true,
          cancelButtonColor: 'green',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          reverseButtons: true,
          customClass: {
            container: 'custom-swal-container',
            icon: 'custom-swal-icon',
            title: 'custom-swal-title',
          },
        });
        if (result.isConfirmed) {
          setPasswordAtNextLogon(true);
        } else {
          setPasswordAtNextLogon(false);
        }
      }
    }
  };

  const onRadioChange = (e) => {
    setShowForm(e.target.value);
  };

  return (
    <>
      {loading && <ModalOpenLoader />}
      {changemodal ? (
        <Row className='af-profile-change-wrap'>
          <Col span={24} className='af-profile-change-subwrap'>
            <Form
              size='large'
              labelCol={{ span: 7 }}
              form={form}
              name='register'
              onFinish={onFinish}
              scrollToFirstError
              initialValues={{
                userName: changePassUser,
                olPassword: '',
                newPassword: '',
                confirmPassword: '',
                fqdn: selectedNode.domainName,
              }}
              className='af-profile-change-formwrap'
            >
              <h2 className='af-profile-change-heading'>Change Password</h2>

              <Form.Item name='userName' label='User Name' className='af-profile-change-form-item-user'>
                <Input readOnly className='input_noChange' />
              </Form.Item>
              <Form.Item
                name='oldPassword'
                label='Current Password'
                rules={[
                  {
                    required: true,
                    message: 'Please enter current password',
                  },
                ]}
                className='af-profile-change-form-item-oldpass'
              >
                <Input.Password className='af-profile-change-input-oldpass' />
              </Form.Item>
              <Form.Item
                name='newPassword'
                label='New Password'
                rules={[
                  {
                    required: true,
                    message: 'Please enter new password',
                  },
                ]}
                className='af-profile-change-form-item-newpass'
              >
                <Input.Password className='af-profile-change-input-newpass' />
              </Form.Item>
              <Form.Item
                name='confirmPassword'
                label='Confirm Password'
                dependencies={['newPassword', 'oldPassword']}
                rules={[
                  {
                    required: true,
                    message: 'Please confirm your password',
                  },
                  {
                    validator: validatePasswordMatch,
                  },
                ]}
                className='af-profile-change-form-item-confirmpass'
              >
                <Input.Password className='af-profile-change-input-confirmpass' />
              </Form.Item>
              <Form.Item name='fqdn' label='Domain' style={{ display: 'none' }}>
                <Input readOnly className='input_noChange' />
              </Form.Item>
              <FormSubmitButtonConatainer className='af-profile-change-form-item-submit'>
                <StyledButton
                  type='primary'
                  htmlType='submit'
                  disabled={!passwordMatch}
                  className='af-profile-change-submit-button'
                >
                  Submit
                </StyledButton>
              </FormSubmitButtonConatainer>
            </Form>
          </Col>
        </Row>
      ) : (
        <Row className='af-admin-reset-wrap'>
          <Col span={24} className='af-admin-reset-subwrap'>
            <Form
              size='large'
              labelCol={{ span: 7 }}
              form={form}
              name='register'
              onFinish={onFinish}
              scrollToFirstError
              initialValues={{
                strUserName: record.samAccountName,
                strNewPassword: '',
                fqdn: selectedNode.domainName,
                passwordAtNextLogon: singleUserData?.passwordAtNextLogon,
                notifyEmail: canNotify,
              }}
              className='af-admin-reset-formwrap'
            >
              <h2 className='af-admin-reset-heading'>Reset Password</h2>

              <Form.Item
                name='radio-button'
                style={{ marginBottom: '0px', display: 'flex', justifyContent: 'center', marginLeft: '5px' }}
                className='af-admin-reset-form-item-radio'
              >
                <Radio.Group onChange={onRadioChange} defaultValue='random' className='af-admin-reset-radiogroup'>
                  <Radio value='random' className='af-admin-reset-radio-random'>
                    Random Password
                  </Radio>
                  <Radio value='manual' style={{ marginBottom: '10px' }} className='af-admin-reset-radio-manual'>
                    Manual
                  </Radio>
                  <Radio value='link' className='af-admin-reset-radio-link'>
                    Send Reset Link
                  </Radio>
                </Radio.Group>
              </Form.Item>

              <Form.Item
                name='strUserName'
                label='User Name'
                style={{ marginBottom: 10 }}
                className='af-admin-reset-form-item-user'
              >
                <Input readOnly className='input_noChange' />
              </Form.Item>
              {showForm === 'manual' && (
                <>
                  <Form.Item
                    name='strNewPassword'
                    label='New Password'
                    rules={[
                      {
                        required: true,
                        message: 'Please enter the password',
                      },
                    ]}
                    style={{ marginBottom: 10 }}
                    className='af-admin-reset-form-item-newpass'
                  >
                    <Input.Password className='af-admin-reset-input-newpass' />
                  </Form.Item>
                  <Form.Item
                    name='confirm_password'
                    label='Confirm Password'
                    dependencies={['strNewPassword']}
                    rules={[
                      {
                        required: true,
                        message: 'Please confirm your password',
                      },
                      {
                        validator: validatePasswordMatch,
                      },
                    ]}
                    style={{ marginBottom: 0 }}
                    className='af-admin-reset-form-item-confirmpass'
                  >
                    <Input.Password className='af-admin-reset-input-confirmpass' />
                  </Form.Item>
                  <Form.Item
                    label='generate'
                    name='generate'
                    className='hidden_label visible-hidden af-admin-reset-form-item-generate'
                    style={{ marginBottom: 10 }}
                  >
                    <Link onClick={handleGeneratePassword}>Generate</Link>
                  </Form.Item>
                </>
              )}
              {showForm !== 'link' && (
                <>
                  <Form.Item
                    label='nextlogon'
                    key='passwordAtNextLogon'
                    name='passwordAtNextLogon'
                    className='hidden_label visible-hidden af-admin-reset-form-item-nextlogon'
                    style={{ marginBottom: '0px' }}
                  >
                    <Checkbox
                      checked={passwordAtNextLogon}
                      onChange={onCheckboxChange}
                      className='af-admin-reset-nextlogon-checkbox'
                    >
                      Force user to change password on next login.
                    </Checkbox>
                  </Form.Item>

                  <Form.Item
                    label='Notify by email'
                    key='notifyByMail'
                    name='notifyEmail'
                    className='hidden_label visible-hidden af-admin-reset-form-item-notifyEmail'
                    valuePropName='checked'
                  >
                    <Checkbox checked={canNotify} className='af-admin-reset-notifyEmail-checkbox'>
                      Notify by email
                    </Checkbox>
                  </Form.Item>
                </>
              )}
              <Form.Item name='fqdn' label='Domain' style={{ display: 'none' }}>
                <Input readOnly className='input_noChange' />
              </Form.Item>
              <FormSubmitButtonConatainer className='af-admin-reset-form-item-submit'>
                <StyledButton
                  className='af-admin-reset-submit-button'
                  type='primary'
                  htmlType='submit'
                  disabled={!passwordMatch && showForm === 'manual'}
                >
                  Submit
                </StyledButton>
              </FormSubmitButtonConatainer>
            </Form>
          </Col>
        </Row>
      )}
    </>
  );
}
